import Icon from '../components/Icon.vue'

Icon.register({"mouse-pointer":{"width":1280,"height":1792,"paths":[{"d":"M1133 1043q31 30 14 69-17 40-59 40h-382l201 476q10 25 0 49t-34 35l-177 75q-25 10-49 0t-35-34l-191-452-312 312q-19 19-45 19-12 0-24-5-40-17-40-59v-1504q0-42 40-59 12-5 24-5 27 0 45 19z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mouse-pointer.js
// module id = 489
// module chunks = 0